<div class="flex flex-col h-full overflow-hidden" *transloco="let t">
    <div class="flex flex-row items-center place-content-between pl-4 pr-2 pt-2 pb-4">
        <span class="font-bold">{{ form.title }}</span>
        <button mat-icon-button (click)="dialogRef.close()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div class="mat-typography p-6 h-full overflow-y-auto">
        <div class="pb-6 text-hint" *ngIf="form.description">
            {{ form.description }}
        </div>
        <form-view [definition]="definition" [formModel]="form" [standalone]="true"></form-view>
    </div>
    <div class="flex flex-row items-center place-content-end m-4">
        <button mat-button (click)="dialogRef.close()" cdkFocusInitial>
            {{ t("actions.close") }}
        </button>
    </div>
</div>
